/* eslint-disable react-hooks/exhaustive-deps */
import {
  Col,
  Row,
  Radio,
  RadioChangeEvent,
  Input,
  Form,
  Select,
  Checkbox,
  Button,
  FormInstance,
  Modal,
  Divider,
  message,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import MUIDatePicker from '../../../components/MaterialUI/DatePicker';
import {
  getCities,
  getPostalCodes,
  getStates,
  getSubCities,
} from '../../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { getShippingCost } from '../../../reducers/actions/shipment';
import {
  applyPromotion,
  IApplyPromotion,
  updateOrderStore,
} from '../../../reducers/actions/order';
import {
  speningOn,
  speningOff,
} from '../../../reducers/actions/spening';
import { convertPrice } from '../../../utils/display';
import moment from 'moment';

interface IProps {
  form: FormInstance;
}

const ShippingInfo: React.FC<IProps> = ({ form }) => {
  const deliveryTimeOptions = [
    { label: '08.00 - 09.00 น.', value: '8/00' },
    { label: '09.00 - 10.00 น.', value: '9/00' },
    { label: '10.00 - 11.00 น.', value: '10/00' },
    { label: '11.00 - 12.00 น.', value: '11/00' },
    { label: '12.00 - 13.00 น.', value: '12/00' },
    { label: '13.00 - 14.00 น.', value: '13/00' },
    { label: '14.00 - 15.00 น.', value: '14/00' },
    { label: '15.00 - 16.00 น.', value: '15/00' },
    { label: '16.00 - 17.00 น.', value: '16/00' },
  ];

  const { order, currentAddress, currentLocation, settings, user } =
    useSelector((state: any) => state);
  const [isShowUserAddresses, setIsShowUserAddresses] =
    useState(false);
  const [promotionCode, setPromotionCode] = useState('');
  const [isApplyPromotion, setIsApplyPromotion] = useState(false);
  const [postalCodes, setPostalCodes] = useState<any>([]);
  const [subCities, setSubCities] = useState<any>([]);
  const [cities, setCities] = useState<any>([]);
  const [states, setStates] = useState<any>([]);
  const [deliveryCost, setDeliveryCost] = useState<number>(0);
  const [isDisableAddress, setIsDisableAddress] = useState(false);
  const [deliveryType, setDeliveryType] = useState('จัดส่งปกติ');
  const [orderDetail, setOrderDetail] = useState(order);
  const [canShipping, setCanShipping] = useState(true);
  const [postCode, setPostCode] = useState();
  const [city, setCity] = useState();
  const [subCity, setSubCity] = useState();
  const [province, setProvince] = useState();
  const dispatch = useDispatch();

  const deliveryTypeOptions = [
    {
      label: 'จัดส่งปกติ',
      value: 'จัดส่งปกติ',
      disabled: !canShipping,
    },
    {
      label: 'รับเองที่ร้าน',
      value: 'รับเองที่ร้าน',
      disabled: false,
    },
  ];

  useEffect(() => {
    setOrderDetail(order);
    form.setFieldsValue({
      shipmentDate: moment().add(1, 'day'),
    });
  }, [order]);

  const onChangeDeliveryType = async ({
    target: { value },
  }: RadioChangeEvent) => {
    setDeliveryType(value);
    const shipping = await calculateShippingCost(value);
    if (!shipping) {
      message.error(`ไม่สามารถจัดส่งไปยังพื้นที่ของท่านได้`);
      setCanShipping(false);
      setDeliveryType('รับเองที่ร้าน');
    } else {
      setCanShipping(true);
      dispatch(updateOrderStore({ ...order, ...shipping }));
    }
  };

  const calculateShippingCost = async (deliveryType: string) => {
    dispatch(speningOn());
    const delivery = await getShippingCost(
      orderDetail,
      deliveryType,
      form.getFieldsValue().subCity,
      currentLocation,
      settings
    );

    setDeliveryCost(delivery.deliveryCost);
    const shipmentDiscount =
      deliveryType === 'รับเองที่ร้าน' ? 0 : order.shipment_discount;
    const totalPriceNet =
      order.totalPrice +
      (delivery.deliveryCost || 0) -
      (shipmentDiscount || 0) -
      (order.discount || 0);
    dispatch(speningOff());

    if (!delivery.canShipping) {
      return delivery.canShipping;
    }

    return {
      ...delivery,
      shipment_discount: shipmentDiscount,
      totalPriceNet: totalPriceNet,
    };
  };

  const onChangeRecipient = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      form.setFieldsValue({
        customerName: user.displayName,
        customerPhone: user.phone,
      });
    } else {
      form.setFieldsValue({
        customerName: '',
        customerPhone: '',
      });
    }
  };

  const onPostalCodeChange = async (postcode: any) => {
    const subCities = await getSubCities(postcode);
    setSubCities(subCities);
    setPostCode(postcode);
    return;
  };

  const onSubCityChange = async (value: any = null) => {
    setCities(await getCities(value));
    setSubCity(value);
    return;
  };

  const onCityChange = async (value: any = null) => {
    setStates(await getStates(value));
    setCity(value);
    return;
  };

  const initialPostalCode = async () => {
    setPostalCodes(await getPostalCodes());
  };

  useEffect(() => {
    const doing = async () => {
      const shipping = await calculateShippingCost('จัดส่งปกติ');
      if (!shipping) {
        message.error(`ไม่สามารถจัดส่งไปยังพื้นที่ของท่านได้`);
        setCanShipping(false);
        setDeliveryType('รับเองที่ร้าน');
      } else {
        setCanShipping(true);
        dispatch(updateOrderStore({ ...order, ...shipping }));
      }
    };
    if (postCode && city && subCity && province) {
      doing();
    }
  }, [postCode, city, subCity, province]);

  const onClickUseCurrentLocation = async () => {
    let address = '';
    if (
      currentAddress &&
      currentAddress.results &&
      currentAddress.results.length
    ) {
      const result = currentAddress.results[0];
      if (
        result &&
        result.formatted_address &&
        result.formatted_address.length
      ) {
        address = result.formatted_address
          ? result.formatted_address.split(',')[0]
          : '';
      }
    }

    const postalCodeAddress = currentAddress?.results?.find(
      (address: any) => address.types.includes('postal_code')
    );

    if (
      postalCodeAddress &&
      postalCodeAddress.address_components &&
      postalCodeAddress.address_components.length
    ) {
      const postalCode = get(
        postalCodeAddress.address_components,
        `0.long_name`,
        ''
      );

      if (postalCode) {
        await onPostalCodeChange(postalCode);
        form.setFieldsValue({
          address,
          postalCode,
        });
      }
    }
  };

  const onClickSelectExistingAddress = () => {
    setIsShowUserAddresses(true);
  };

  const onClickSelectAddress = async (index: number) => {
    const addressSelect = user.addresses[index];
    await onSubCityChange(addressSelect.subCity._id);
    await onCityChange(addressSelect.city._id);
    form.setFieldsValue({
      address: addressSelect.address,
      postalCode: addressSelect.postalCode.name,
      subCity: addressSelect.subCity.name,
      city: addressSelect.city._id,
      state: addressSelect.state._id,
    });
    setIsShowUserAddresses(false);
  };

  useEffect(() => {
    initialPostalCode();
    setDeliveryType('จัดส่งปกติ');
  }, []);

  useEffect(() => {
    onClickUseCurrentLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLocation, currentAddress]);

  useEffect(() => {
    if (subCities.length) {
      form.setFieldsValue({
        subCity: subCities[0].value,
      });
      onSubCityChange(subCities[0].value);
    }
  }, [subCities]);

  useEffect(() => {
    if (cities.length) {
      form.setFieldsValue({
        city: cities && cities.length ? cities[0]?.value : null,
      });

      onCityChange(cities && cities[0]?.value);
    }
  }, [cities]);

  useEffect(() => {
    if (states.length) {
      form.setFieldsValue({
        state: states && states.length ? states[0].value : null,
      });
      setProvince(states && states.length ? states[0].value : null);
    }
  }, [states]);

  useEffect(() => {
    setIsDisableAddress(deliveryType === 'รับเองที่ร้าน');
  }, [deliveryType]);

  // useEffect(() => {
  //   if (currentLocation) {
  //     form.setFieldsValue({
  //       deliveryType: 'จัดส่งปกติ',
  //     });
  //   }
  // }, [currentLocation]);

  const onChangePromotionCode = (event: any) => {
    setPromotionCode(event.target.value);
  };

  const onApplyPromotion = async () => {
    if (deliveryType === undefined) {
      message.error('กรุณาเลือกการจัดส่งก่อน');
      return;
    }
    const products = order.products.map((product: any) => {
      return {
        productId: product.product._id.product.code
          ? product.product._id.product.code
          : product.product._id.product.codeGenerate,
        qty: product.amount,
        unit: 'PC',
        price: product.product._id.memberPrice,
      };
    });

    const params: IApplyPromotion = {
      order: order,
      promotionCode,
      cartProducts: products,
      totalAmount: order.totalPrice,
      totalDeliveryCost: order.deliveryCost,
      sellerCode: order.shop.code,
      userId: user._id,
    };
    const applyPromotionResult = await applyPromotion(params);
    if (applyPromotionResult.data.promotionCode !== null) {
      setIsApplyPromotion(true);
    }
    dispatch(applyPromotionResult);
  };

  return (
    <div style={{ background: '#fff', padding: '8px' }}>
      <div style={{ width: '100%' }}>
        <Form.Item
          name={'deliveryType'}
          rules={[
            { required: true, message: 'กรุณาเลือกการจัดส่ง!' },
          ]}
        >
          <Radio.Group
            value={deliveryType}
            defaultValue={deliveryType}
            style={{ width: '100%' }}
            options={deliveryTypeOptions}
            onChange={onChangeDeliveryType}
            optionType="button"
            buttonStyle="solid"
            size="large"
          />
        </Form.Item>

        <Row gutter={[8, 8]}>
          <Col span={12}>
            <Form.Item
              label="เลือกวันที่จัดส่ง"
              name="shipmentDate"
              rules={[
                { required: true, message: 'กรุณากรอกข้อมูล!' },
              ]}
            >
              <MUIDatePicker
                placeholder="วันที่"
                value={
                  form.getFieldsValue().shipmentDate ||
                  moment().add(1, 'days')
                }
                onChange={(event: any) => {
                  form.setFieldsValue({
                    shipmentDate: event,
                  });
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="เลือกเวลาจัดส่ง"
              name="shipmentTime"
              rules={[
                { required: true, message: 'กรุณากรอกข้อมูล!' },
              ]}
            >
              <Select
                style={{ width: '100%' }}
                placeholder="เวลา"
                options={deliveryTimeOptions}
              ></Select>
            </Form.Item>
          </Col>
        </Row>

        <Row
          gutter={[8, 0]}
          style={{
            display: `${isDisableAddress ? 'none' : 'flex'}`,
          }}
        >
          <Col span={12}>
            <Form.Item
              label={<span>ผู้รับสินค้า</span>}
              name="customerName"
              rules={[
                {
                  required: !isDisableAddress,
                  message: 'กรุณากรอกข้อมูล!',
                },
              ]}
              style={{ rowGap: '0px' }}
            >
              <Input placeholder="ชื่อ" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="เบอร์โทรศัพท์"
              name="customerPhone"
              rules={[
                {
                  required: !isDisableAddress,
                  message: 'กรุณากรอกข้อมูล!',
                },
              ]}
            >
              <Input placeholder="เบอร์โทรศัพท์" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Checkbox onChange={onChangeRecipient}>
              ผู้รับสินค้าคนเดียวกับผู้ซื้อ
            </Checkbox>
            <div style={{ marginBottom: '12px' }} />
          </Col>
        </Row>
      </div>
      <div
        style={{
          display: `${isDisableAddress ? 'none' : 'block'}`,
        }}
      >
        <Row justify="end" gutter={[8, 8]}>
          <Col>
            <Button
              onClick={onClickUseCurrentLocation}
              name="btnCurrentAddress"
              type="dashed"
            >
              <img
                style={{ paddingBottom: '5px' }}
                alt=""
                src={`/images/location_on_24px.svg`}
              />
              ใช้ที่อยู่ปัจจุบัน
            </Button>
          </Col>
          <Col>
            <Button
              name="btnChooseAddress"
              onClick={onClickSelectExistingAddress}
              type="dashed"
            >
              เลือกที่อยู่จากที่บันทึกไว้
            </Button>
          </Col>
        </Row>
        <div style={{ marginTop: '12px' }}>
          <Form.Item
            name={`address`}
            label={`ที่อยู่`}
            rules={[
              {
                required: !isDisableAddress,
                message: 'กรุณากรอกข้อมูล!',
              },
            ]}
          >
            <Input.TextArea
              style={{ width: '100%' }}
              value={`address`}
              placeholder="รายละเอียดที่อยู่"
            />
          </Form.Item>

          <Row gutter={[8, 8]}>
            <Col span={12}>
              <Form.Item
                name={`postalCode`}
                label={`รหัสไปรษณีย์`}
                rules={[
                  {
                    required: !isDisableAddress,
                    message: 'กรุณากรอกข้อมูล!',
                  },
                ]}
              >
                <Select
                  showSearch
                  onChange={onPostalCodeChange}
                  options={postalCodes}
                  placeholder="รหัสไปรษณีย์"
                ></Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name={`subCity`}
                label={`แขวง / ตำบล`}
                rules={[
                  {
                    required: !isDisableAddress,
                    message: 'กรุณากรอกข้อมูล!',
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption={(input, option: any) =>
                    option.label.indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={onSubCityChange}
                  options={subCities}
                  placeholder="แขวง / ตำบล"
                ></Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[8, 8]}>
            <Col span={12}>
              <Form.Item
                name={`city`}
                label={`เขต / อำเภอ`}
                rules={[
                  {
                    required: !isDisableAddress,
                    message: 'กรุณากรอกข้อมูล!',
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption={(input, option: any) =>
                    option.label.indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={onCityChange}
                  options={cities}
                  placeholder="เขต / อำเภอ"
                ></Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name={`state`}
                label={`จังหวัด`}
                rules={[
                  {
                    required: !isDisableAddress,
                    message: 'กรุณากรอกข้อมูล!',
                  },
                ]}
              >
                <Select
                  showSearch
                  options={states}
                  placeholder="จังหวัด"
                ></Select>
              </Form.Item>
            </Col>
          </Row>
        </div>
      </div>
      <div>
        <Form.Item name={`remark`} label={` `}>
          <Input.TextArea
            style={{ width: '100%' }}
            placeholder="หมายเหตุ"
          />
          <span style={{ color: '#999' }}>
            ข้อความถึงร้าน หากต้องการใบกำกับภาษีกรุณากรอกชื่อ ที่อยู่
            และเลขประจำตัวผู้เสียภาษี
          </span>
        </Form.Item>
      </div>

      <div
        style={{
          background: '#fff',
          borderRadius: '5px',
          padding: '4px',
          marginBottom: '4px',
        }}
      >
        <b>โค้ดส่วนลดพร้อมดี</b>
        <Input.Group size="large" compact>
          <Input
            name="inputPromotionCode"
            style={{ width: 'calc(100% - 100px)' }}
            value={promotionCode}
            onChange={onChangePromotionCode}
            disabled={isApplyPromotion}
          />
          <Button
            name="btnApplyCode"
            size="large"
            style={{ width: '100px' }}
            onClick={onApplyPromotion}
            disabled={isApplyPromotion}
            type="default"
          >
            ใช้ส่วนลด
          </Button>
        </Input.Group>
        <span style={{ color: '#f00' }}>{order.promotionError}</span>
      </div>
      <br />
      <Row justify="space-between" style={{ fontSize: '16px' }}>
        <Col>ค่าขนส่ง</Col>
        <Col style={{ color: '#045de9' }}>
          {convertPrice(order.deliveryCost)}
        </Col>
      </Row>
      <Row justify="space-between" style={{ fontSize: '16px' }}>
        <Col>ส่วนลดค่าขนส่ง</Col>
        <Col style={{ color: 'crimson' }}>
          {convertPrice(order.shipment_discount || 0)}
        </Col>
      </Row>
      <Row justify="space-between" style={{ fontSize: '16px' }}>
        <Col>ส่วนลดค่าสินค้า</Col>
        <Col style={{ color: 'crimson' }}>
          -{convertPrice(order.discount || 0)}
        </Col>
      </Row>
      {order.gift ? (
        <Row
          gutter={[8, 8]}
          justify="space-between"
          style={{ fontSize: '16px' }}
        >
          <Col>ของแถม</Col>
          <Col style={{ color: 'green' }}>
            {order.gift.name} {order.gift.qty} ชิ้น
          </Col>
        </Row>
      ) : (
        <></>
      )}
      <Row
        gutter={[16, 16]}
        justify="space-between"
        style={{
          padding: '8px',
          fontSize: '18px',
          color: '#fff',
          backgroundColor: '#ccc',
        }}
      >
        <Col style={{ color: '#555' }}>
          ยอดชำระทั้งหมด
          <br />
          <span style={{ color: '#045de9' }}>
            {convertPrice(order.totalPriceNet || order.totalPrice)}{' '}
            บาท
          </span>
        </Col>
        <Col span="8" style={{ lineHeight: 3 }}>
          <Button
            name="btnPayment"
            block
            size="large"
            type="primary"
            htmlType="submit"
            disabled={!canShipping}
          >
            ชำระเงิน
          </Button>
        </Col>
      </Row>

      <Modal
        title="ที่อยู่ของฉัน"
        visible={isShowUserAddresses}
        footer={false}
      >
        {user.addresses.map((address: any, index: number) => {
          return (
            <div key={index}>
              <Row justify="space-between">
                <Col>
                  <div>{address.address}</div>
                  <div>
                    {address.subCity.name} {address.city.name}{' '}
                    {address.state.name} {address.postalCode.name}
                  </div>
                </Col>
                <Col>
                  <Button
                    name="btnselectAddress"
                    key={index}
                    onClick={() => onClickSelectAddress(index)}
                    type="primary"
                  >
                    เลือก
                  </Button>
                </Col>
              </Row>
              <Divider
                style={{
                  background: '#ccc',
                  margin: '15px 0',
                }}
              ></Divider>
            </div>
          );
        })}
      </Modal>
    </div>
  );
};

export default ShippingInfo;
